module.exports = __webpack_public_path__ + "img/meinbezirk.42f05b5a.svg";